export const ReadOnlyOverlay = () => {
  const styles = {
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 2147483647,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  } as React.CSSProperties;

  return <div className="read-only-overlay" style={styles}></div>;
};
